import ErrorStatePage from './ErrorStatePage';

export default function AccessDeniedPage() {
    return <ErrorStatePage code="403" title="Acesso negado" description="Seu perfil não possui permissão para acessar esta área do sistema." />;
}
